// フォント等、テンプレートに依存しない基盤の定義。
// 「どんな変数を編集できるか」はテンプレート側の fields(templates/shared.ts の Field)が
// 単一情報源として持ち、フロントはそれを読んでフォームを自動生成する。

export type FontKind = "gothic" | "mincho";

// プレビューに使うテンプレートの識別子。registry(templates.ts)のキーと一致させる。
export type TemplateKind = "standard" | "corporate";

// 編集状態。values はスキーマ(テンプレートの fields)のキー -> 現在値。
// 色・フォント・文言・画像(data URL)をすべて同じマップに格納する。
export interface DesignConfig {
  template: TemplateKind;
  values: Record<string, string>;
}

// Noto Sans/Serif JP を Google Fonts から読み込み(FONT_HREF)、100–900 のウェイトを
// ブラウザ・OS を問わず正確に反映する。日本語システムフォントは実質2ウェイトしか持たず
// 500/700/800/900 が潰れるため。読み込み前・オフライン時は後段のシステムフォントへ
// フォールバックする(font-display:swap)。
export const FONT_STACKS: Record<FontKind, string> = {
  gothic:
    '"Noto Sans JP", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Yu Gothic Medium", "Yu Gothic", "Meiryo", system-ui, sans-serif',
  mincho:
    '"Noto Serif JP", "Hiragino Mincho ProN", "Yu Mincho", "YuMincho", "MS PMincho", serif',
};

// フォント種別ごとの Google Fonts スタイルシート URL。必要なウェイトのみ要求する。
export const FONT_HREF: Record<FontKind, string> = {
  gothic:
    "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;800;900&display=swap",
  mincho:
    "https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@400;500;700;900&display=swap",
};

export const FONT_OPTIONS: { value: FontKind; label: string }[] = [
  { value: "gothic", label: "ゴシック体" },
  { value: "mincho", label: "明朝体" },
];
